import { render, staticRenderFns } from "./FloatFormPanel.vue?vue&type=template&id=3b6b9472&scoped=true"
import script from "./FloatFormPanel.vue?vue&type=script&lang=js"
export * from "./FloatFormPanel.vue?vue&type=script&lang=js"
import style0 from "./FloatFormPanel.vue?vue&type=style&index=0&id=3b6b9472&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b9472",
  null
  
)

export default component.exports